<template>
  <div class="container mt40">
    <div class="common-detail-content">
      <!-- 上半部 -->
      <div class="content-box">
        <div class="header">
          <div class="banner-box">
            <div class="left">
              <div class="banner">
                <el-carousel ref="carousel" :interval="5000" arrow="always" height="356px" :initial-index="bannerIdx">
                  <el-carousel-item v-for="(item,index) in banners" :key="index">
                    <img :style="{width: '100%', height: '100%'}" :src="item" alt="">
                  </el-carousel-item>
                </el-carousel>
              </div>
              <div class="banner-label">
                <div :class="['banner-label-item', bannerActiveIdx == 0 ? 'active' : '']" @click="bannerChange(0)">全部图片({{info.bannerTotalNum || 0}})</div>
                <template v-if="info.bannerList.length > 0">
                  <div :class="['banner-label-item', bannerActiveIdx === index + 1 ? 'active' : '']" v-for="(item, index) in info.bannerList" :key="index" @click="bannerChange(index + 1)">{{item.title}}({{item.imgList.length}})</div>
                </template>
              </div>
            </div>

            <div class="right">
              <div class="title subname">
                <div class="title-name">{{info.upname}}</div>
                <div class="title-name">{{info.downname}}</div>
              </div>
              <div class="synopsis">
                <p :class="{'show-all': showAll===true}">{{info.synopsis}}</p>
                <span class="btn" @click="handleShow">{{showAll?'点击收起':'查看全部'}}</span>
              </div>
              <div class="contactway">
                <div class="contactway-item">
                  <div class="label">开放时间:</div>
                  <div class="text">
                    <span>{{info.openingTime}}</span>
                    <span class="open-status">{{info.openStatus}}</span>
                  </div>
                </div>
                <div class="contactway-item">
                  <div class="label">景点地址:</div>
                  <div class="text">
                    {{info.addressDetails}}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="flat-pattern">
            <div class="left-arrows" :class="{disabled: banners.length <= 6 || moveLeft === 0}" @click="handleBannerPrev"></div>
            <div class="img-list">
              <div class="img-box" :style="{left: -moveLeft + 'px'}">
                <div class="img-item" v-for="(item,index) in banners" :key="index">
                  <img :src="item" alt="" @click="bannerIdxSel(index)">
                </div>
              </div>
            </div>
            <div class="right-arrows" :class="{disabled: banners.length <= 6 || moveLeft === (banners.length - 6) * imgHeight}" @click="handleBannerNext"></div>
          </div>
        </div>
        <!-- 预订门票  -->
        <div class="trip-book">
          <div class="trip-book-left" :class="auto_fixed">
            <div @click="handleToPoint(item.id, index)" v-for="(item, index) in navList" :key="index" :class="navIndex === index ? 'active' : ''">{{item.name}}</div>
          </div>
          <div class="trip-book-right" :class="{ ml180: auto_fixed.fixed }">
            <!-- 预订门票 -->
            <div class="step-jump" id="tripbook">
              <div class="book-block">
                <div class="title">
                  <span class="border"></span>
                  <span>预订门票</span>
                </div>
                <div class="use-date">
                  <div>
                    <p class="label">请选择游玩日期</p>
                    <div class="date-time">
                      <span>{{useStartDate}}</span>
                      <img @click="handleShowDate" src="../../assets/images/home/date-new.png" alt="" />
                      <el-date-picker
                        class="hide-date"
                        ref="startDate"
                        v-model="useStartDate"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        type="date"
                        :picker-options="setDateDisabled"
                        @change="handleUseStartDate"
                      >
                      </el-date-picker>
                    </div>
                  </div>
                  <template v-if="intervalList.length > 0">
                    <div>
                      <p class="label">入园时段</p>
                      <el-dropdown trigger="click" @command="handleInterval">
                        <div class="date-time">
                          <span v-if="intervalObj">{{intervalObj.reservationBeginTime + '~' + intervalObj.reservationEndTime}}</span>
                          <span v-else>可选择入园时段</span>
                          <img src="../../assets/images/home/clock-new.png" alt="" />
                        </div>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item :command="index" :disabled="item.disabled" v-for="(item, index) in intervalList" :key="index">{{item.reservationBeginTime + '-' + item.reservationEndTime}} &nbsp; 剩余：{{item.surplusStockNum}}</el-dropdown-item>
                          <el-dropdown-item :command="-1">清除</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                    <!-- <div class="stock">
                      <p class="label">剩余库存</p>
                      <p class="stocknum">{{totalStockNum}}</p>
                    </div> -->
                  </template>
                </div>
              </div>
              <!-- 产品列表 -->
              <div class="product-list" v-if="proList.length > 0">
                <div v-for="(item, index) in proList" :key="index">
                  <div class="flex-between">
                    <div class="product-left">
                      <img v-if="!item.showDetail" @click="item.showDetail = !item.showDetail" src="../../assets/images/home/down.png" alt="" />
                      <img v-else @click="item.showDetail = !item.showDetail" src="../../assets/images/home/up.png" alt="" />
                      <span>{{item.goodsName}}</span>
                    </div>
                    <div class="product-right">
                      <div class="price">
                        <span class="sale-price"><span class="font-sm">¥</span>{{item.lowestPrice}}</span>
                        <span class="goods-price" v-if="item.goodsPrice != null"><span>¥</span>{{item.goodsPrice}}</span>
                      </div>
                      <div class="num-btn">
                        <img @click="handleChangeQuantity(item, 0)" src="../../assets/images/home/reduce.png" alt="" />
                        <span>{{item.quantity}}</span>
                        <img @click="handleChangeQuantity(item, 1)" src="../../assets/images/home/add.png" alt="" />
                      </div>
                    </div>
                  </div>
                  <div class="product-detail richContent" v-if="item.showDetail" v-html="getRichContent(item.goodsSummary)"></div>
                </div>
              </div>
              <div v-else class="text-center mt60">暂无产品</div>
            </div>
            <!-- 预订须知 -->
            <div class="mt60 step-jump" id="reserveNotes">
              <div class="title">
                <span class="border"></span>
                <span>预订须知</span>
              </div>
              <div class="mt18 richContent" v-html="getRichContent(info.reservationNotes)"></div>
            </div>
            <!-- 景点介绍 -->
            <div class="mt60 step-jump" id="introduce">
              <div class="title">
                <span class="border"></span>
                <span>景点介绍</span>
              </div>
              <div class="mt18 richContent" v-html="getRichContent(info.introduce)"></div>
            </div>
            <!-- 交通指南 -->
            <div class="mt60 step-jump" id="trafficGuide">
              <div class="title">
                <span class="border"></span>
                <span>交通指南</span>
              </div>
              <div class="mt18 richContent" v-html="getRichContent(info.trafficGuide)"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-badge :value="totalNum" class="item">
      <div @click="handleToBook">
        <img class="cart" src="../../assets/images/home/cart.png" alt="" />
        <p class="cart-span">点击结算</p>
      </div>
    </el-badge>
  </div>
</template>

<script>
import { formatDate, dateBeforeorAfter } from '@/utils/validate'
import { getProductlist, getTripDetail, findIntervalListByIndustry, getInfo } from '@/api/buyTicket_xqs'
import { queryDetailMixin } from '@/mixins/queryDetailMixin'
import { config } from '@/constant/config'
export default {
  mixins: [queryDetailMixin],
  data () {
    return {
      moduleType: 'TRIP',
      navIndex: 0,
      navList: [
        { id: '#tripbook', name: '预订门票' },
        { id: '#reserveNotes', name: '预订须知' },
        { id: '#introduce', name: '景点介绍' },
        { id: '#trafficGuide', name: '交通指南' }
      ],
      showAll: false,
      totalNum: 0,
      useStartDate: formatDate('yyyy-MM-dd', new Date()),
      isOpenInterval: false,
      totalStockNum: 0,
      intervalList: [],
      intervalObj: null,
      auto_fixed: {
        fixed: false
      },
      aheadDays: null,
      aheadHours: null,
      aheadMinute: null
    }
  },
  computed: {
    // 入住日期禁用
    setDateDisabled () {
      const that = this
      return {
        disabledDate (time) {
          let disabled = false
          // 判断日期是否在规则配置可售日期范围内
          if (that.aheadHours == null) {
            // 可提前
            const ealiestAvailableTime = new Date(formatDate('yyyy-MM-dd', dateBeforeorAfter(that.aheadDays))).getTime()
            disabled = ealiestAvailableTime < time.getTime()
          } else if (that.aheadDays > 0) {
            // 需提前
            const timeStr = (that.aheadHours < 10 ? ('0' + that.aheadHours) : that.aheadHours) + ':' + (that.aheadMinute < 10 ? ('0' + that.aheadMinute) : that.aheadMinute) + ':00'
            const latestAvailableTime = new Date(formatDate('yyyy-MM-dd', dateBeforeorAfter(-that.aheadDays, time)) + ' ' + timeStr).getTime()
            if (latestAvailableTime < new Date().getTime()) {
              disabled = true
            }
          }
          if (time.getTime() < new Date().getTime() - 24 * 60 * 60 * 1000) {
            disabled = true
          }
          return disabled
        }
      }
    }
  },
  created () {
    this.getInfo()
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('scroll', this.onScroll)
    })
  },
  methods: {
    // 富文本处理
    getRichContent (content) {
      if (content && typeof (content) === 'string') {
        const regexPre = new RegExp('pre>', 'g')
        content = content.replace(regexPre, 'div>')
      }
      return content
    },
    onScroll () {
      let scrolled = document.documentElement.scrollTop || document.body.scrollTop
      // 滑动时左侧菜单高亮处理
      let article = document.querySelectorAll('.step-jump')
      article.forEach((item, index) => {
        if (scrolled >= item.offsetTop) {
          this.navIndex = index
        }
      })
      // 根据距离决定是否fixed
      let headerHeight = null
      if (document.getElementsByClassName('header')[0]) {
        headerHeight = document.getElementsByClassName('header')[0].offsetHeight
      }
      this.auto_fixed = {
        auto_fixed: true,
        fixed: scrolled >= headerHeight + 160
      }
    },
    // 判断票规则配置的预订限制
    getAvailableDaysfromRule (rule) {
      if (rule.optionJson != null) {
        const optionJson = JSON.parse(rule.optionJson)
        if (optionJson.needTimeUnit == null || optionJson.needTimeUnit === 'DAY') {
          // 同是提前多少天
          if (optionJson.needTimeUnit == null) {
            if (this.aheadDays == null || optionJson.day < this.aheadDays) {
              this.aheadDays = optionJson.day
              this.aheadHours = optionJson.hour
              this.aheadMinute = optionJson.minute
            }
          } else {
            if (optionJson.needTime > optionJson.day) {
              if (this.aheadDays == null || optionJson.needTime < this.aheadDays) {
                this.aheadDays = optionJson.needTime
              }
            } else {
              if (this.aheadDays == null || optionJson.day < this.aheadDays) {
                this.aheadDays = optionJson.day
              }
            }
          }
        } else if (optionJson.needTimeUnit === 'HOUR') {
          if (optionJson.day === 0) {
            // 同是当天
            this.aheadDays = 0
            if (this.aheadHours == null || optionJson.hour < this.aheadHours) {
              if (optionJson.needTime == null) {
                this.aheadHours = optionJson.hour
                if (this.aheadMinute == null || this.aheadMinute < optionJson.minute) {
                  this.aheadMinute = optionJson.minute
                }
              }
            } else if (optionJson.hour === this.aheadHours) {
              if (this.aheadMinute == null || this.aheadMinute < optionJson.minute) {
                this.aheadMinute = optionJson.minute
              }
            }
          } else {
            this.aheadDays = optionJson.day
            if (this.aheadDays == null || optionJson.day < this.aheadDay) {
              this.aheadDays = optionJson.day
              this.aheadHours = optionJson.hour
            }
          }
        } else {
          if (this.aheadDays == null || optionJson.day < this.aheadDay) {
            this.aheadDays = optionJson.day
            this.aheadHours = optionJson.hour
          }
        }
      }
    },
    // 选择游玩日期
    handleUseStartDate (date) {
      if (this.isOpenInterval) {
        this.findIntervalListByIndustry()
      } else {
        this.loadProducts()
      }
    },
    handleShowDate () {
      this.$refs['startDate'].focus()
    },
    // 选择入园时段
    handleInterval (index) {
      if ((index !== -1 && this.intervalObj && this.intervalObj.reservationTemplateId === this.intervalList[index].reservationTemplateId) ||
      (index === -1 && this.intervalObj === null)) {
        return
      }
      if (index === -1) {
        this.intervalObj = null
      } else {
        this.intervalObj = this.intervalList[index]
      }
      this.loadProducts()
    },
    handleToBook (roomId) {
      if (this.totalNum === 0) {
        this.$message.warning('请选择产品')
        return
      }
      if (this.intervalObj && this.totalNum > this.intervalObj.surplusStockNum) {
        this.$message.warning('当前时段库存不足')
        return
      }
      const proList = []
      this.proList.forEach(val => {
        if (val.quantity > 0) {
          proList.push({
            goodsId: val.goodsId,
            goodsName: val.goodsName,
            otherNumber: val.quantity,
            salePrice: val.lowestPrice
          })
        }
      })
      const query = {
        useStartDate: this.useStartDate,
        isOpenInterval: this.isOpenInterval,
        merchIndustryId: this.id,
        merchIndustryName: this.info.name,
        proList: JSON.stringify(proList)
      }
      if (this.intervalObj) {
        query.reservationTemplateId = this.intervalObj.reservationTemplateId
      }
      this.$router.push({ path: 'tripBook', query })
    },
    // 添加/减少产品数量
    handleChangeQuantity (item, flag) {
      if (flag === 1) {
        item.quantity = item.quantity + 1
        this.totalNum = this.totalNum + 1
      } else {
        if (item.quantity > 0) {
          item.quantity = item.quantity - 1
          this.totalNum = this.totalNum - 1
        }
      }
    },
    // 获取景点详情
    loadInfo () {
      getTripDetail(this.id).then(res => {
        if (res.code === 0) {
          res.data.openStatus = '未开园'
          const today = formatDate('yyyy-MM-dd', new Date())
          const arr = res.data.openingTime.split('-')
          if (new Date().getTime() >= new Date(today + ' ' + arr[0] + ':00').getTime() && new Date().getTime() <= new Date(today + ' ' + arr[1] + ':00').getTime()) {
            res.data.openStatus = '开园中'
          }
          this.loadIndustryOrMerchData(res.data)
        }
      })
    },
    // 获取产品列表
    loadProducts () {
      const data = {
        page: 1,
        limit: 99,
        tenantId: config.TENANTID,
        merchId: config.MERCHID,
        merchIndustryIds: [this.id],
        reservationTemplateId: null,
        useDate: this.useStartDate
      }
      if (this.isOpenInterval) {
        if (this.intervalObj) {
          data.reservationTemplateId = this.intervalObj.reservationTemplateId
        } else if (this.intervalList.length > 0) {
          data.reservationTemplateId = ''
        }
      }
      this.totalNum = 0
      getProductlist(data).then(res => {
        res.data[this.id].list.forEach(val => {
          val.quantity = 0
          val.showDetail = false
          val.goodsSummary = val.goodsSummary ? val.goodsSummary : '暂无介绍'
          const buyRule = val.ruleInfoOptionList.find(rule => rule.ruleCode === 'PRESET_RESTRICTION')
          if (buyRule != null) this.getAvailableDaysfromRule(buyRule)
        })
        this.loadList(res.data[this.id].list || [])
      })
    },
    handleShow () {
      this.showAll = !this.showAll
    },
    handleToPoint (idName, index) {
      this.navIndex = index
      document.querySelector(idName).scrollIntoView(true)
    },
    // 获取分时段配置
    getInfo () {
      getInfo().then(res => {
        if (res.code === 0 && res.data.isOpenInterval === 'T') {
          this.isOpenInterval = true
          this.findIntervalListByIndustry()
        } else {
          this.loadProducts()
        }
      })
    },
    // 获取分时预约列表
    findIntervalListByIndustry () {
      this.intervalList = []
      this.intervalObj = null
      this.totalStockNum = 0
      findIntervalListByIndustry({
        merchIndustryId: this.id,
        useStartDate: this.useStartDate
      }).then(res => {
        if (res.code === 0 && res.data.length > 0) {
          let totalStockNum = 0
          this.intervalList = res.data.map(item => {
            totalStockNum += item.surplusStockNum
            item.disabled = false
            const day = this.useStartDate
            const endTime = new Date(day + ' ' + item.reservationEndTime + ':00').getTime()
            const now = new Date().getTime()
            if (item.surplusStockNum <= 0 || now >= endTime) {
              // 没库存 || 过期
              item.disabled = true
            }
            return item
          })
          this.totalStockNum = totalStockNum
          // const obj = this.intervalList.find(item => !item.disabled)
          // if (obj && obj.reservationTemplateId === this.intervalList[0].reservationTemplateId) {
          //   this.intervalObj = obj
          //   this.loadProducts()
          // }
          this.loadProducts()
          console.log(this.intervalList)
        } else {
          this.loadProducts()
        }
      })
    }
  }
}
</script>
<style lang="scss">
.product-detail {
  img {
    max-width: 100%;
  }
}
</style>

<style scoped lang='scss'>
  .fixed{
    position: fixed;
    top: 30px;
  }
.common-detail-content .content-box {
  padding: 40px;
}
.subname{
  display: block !important;
  line-height: 43px;
}
.top {
  height: 166px;
  width: 100%;
}

.container {
  width: 1279px;
  overflow-x: auto;
}
.synopsis {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #44516F;
  line-height: 22px;
  margin-top: 20px;
  p {
    width:350px;
    display: -webkit-box; /* 弹性盒模型*/
    -webkit-box-orient: vertical; /* 文字垂直排列 */
    -webkit-line-clamp:2; /*文字显示的行数*/
    overflow: hidden;
    &.show-all {
      -webkit-line-clamp: unset;
      overflow: auto;  /*超出部分溢出隐藏*/
    }
    &.show-all::-webkit-scrollbar {
      width: 4px;
    }
    &.show-all::-webkit-scrollbar-thumb {
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
      background: #9B232A;
    }
    &.show-all::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
      border-radius: 0;
      background: #dadde0d7;
    }
  }
  .btn {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    cursor: pointer;
    color: #9B232A;
    opacity: 0.91;
  }
}
.contactway-item {
  .label{
    font-weight: bold !important;
  }
  .open-status {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 19px;
    color: #74C148;
    opacity: 0.91;
    margin-left: 16px;
  }
}
.trip-book {
  margin-top: 80px;
  display: flex;
  .trip-book-left {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 19px;
    color: #242B34;
    width: 180px;
    >div {
      margin-bottom: 40px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 19px;
      color: #242B34;
      display: block;
      cursor: pointer;
    }
    .active {
      font-weight: bold;
      color: #9B232A;
    }
  }
  .ml180 {
    margin-left: 180px;
  }
  .trip-book-right {
    flex: 1;
    .title {
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 24px;
      color: #9B232A;
      display: flex;
      align-items: center;
      .border {
        margin-right: 12px;
        width: 3px;
        height: 18px;
        background: #9B232A;
        opacity: 1;
        border-radius: 4px;
        display: inline-block;
      }
    }
    .book-block {
      .use-date {
        width: 100%;
        box-shadow: 0px 3px 20px rgba(56, 90, 109, 0.11);
        margin-top: 18px;
        padding: 28px 40px;
        box-sizing: border-box;
        display: flex;
        >div {
          width: 40%;
          .label {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 19px;
            color: #9B232A;
            font-weight: bold;
          }
          .date-time {
            margin-top: 15px;
            width: 234px;
            background: #F5F5F7;
            opacity: 1;
            border-radius: 4px;
            padding: 15px 12px 11px 24px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            line-height: 22px;
            color: #242B34;
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: relative;
            img {
              width: 24px;
              height: 24px;
            }
          }
        }
        .stock {
          width: 10%;
          .stocknum {
            font-size: 24px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            line-height: 29px;
            color: #242B34;
            margin-top: 30px;
          }
        }
      }
    }
    .product-list {
      margin-top: 42px;
      >div {
        margin-bottom: 41px;
        .flex-between {
          .product-left {
            display: flex;
            align-items: center;
            img {
              width: 24px;
              height: 24px;
            }
            span {
              font-size: 20px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              line-height: 24px;
              color: #242B34;
              margin-left: 16px;
            }

          }
          .product-right {
            display: flex;
            align-items: center;
            .price {
              display: flex;
              align-items: center;
              .sale-price {
                font-size: 20px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                line-height: 24px;
                color: #FF0000;
              }
              .goods-price {
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                line-height: 17px;
                color: #9FA1B0;
                text-decoration: line-through;
                margin-left: 16px;
              }
              .font-sm {
                font-size: 14px !important;
              }
            }
            .num-btn {
              margin-left: 42px;
              display: flex;
              align-items: center;
              img {
                width: 24px;
                height: 24px;
              }
              span {
                margin: 0 12px;
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                line-height: 19px;
                color: #0D1720;
              }
            }
          }
        }
        .product-detail {
          padding: 28px 36px;
          background: #F5F5F7;
          margin: 18px 0 0 40px;
        }
      }
    }
    .mt60 {
      margin-top: 60px;
    }
    .mt18 {
      margin-top: 18px;
    }
  }
}
.cart {
  width: 98px;
  height: 98px;
}
.cart-span {
  font-size: 18px;
  line-height: 24px;
  color: #9B232A;
  cursor: pointer;
}
.el-badge {
  position: fixed;
  right: 190px;
  bottom: 69px;
  text-align: center;
}
.hide-date {
  position: absolute;
  z-index: -100;
  left: 0;
  top: 0;
}
</style>
